import { useEffect, useState } from "react"
import { useLocation, useNavigate } from 'react-router-dom';
import { singleGameRegistration } from "../api/index";
import { toast } from 'react-hot-toast';

const universityCourses = {
  DIET: ["B.Tech. Civil", "B.Tech. Computer", "B.Tech. Mechanical", "M.Tech. Software", "M.Tech. Structural", "M.Tech. Transportation", "M.Tech. Thermal", "M.Tech. Construction Project Management", "M.Tech. Advanced Design & Manufacturing", "Ph.D. CSE", "Ph.D. Civil", "Ph.D. Mechanical"],
  DIETDS: ["Computer", "Civil", "Electrical", "Mechanical"],
  DICA: ["BCA", "MCA", "B.Sc.(IT)", "B.Sc. Honors(CS)"],
  DIM: ["MBA", "BBA", "BBA-DM", "B.Com", "B.Com (Hons.)", "Ph.D."],
  DIS: ["B.Sc. (Microbiology)", "Ph.D. (Microbiology)"],
  DIH: ["M.A. (Yoga)"]
}

const games = ["Chess", "Badminton", "Yoga", "100 Meter", "200 Meter", "400 Meter", "Javelin Throw", "Shot Put", "Discus Throw", "Rifle Shooting", "Table Tennis"]

const gameWithLink = [{
  name: "Chess",
  link: "https://drive.google.com/file/d/19cTVMVoxnOyGOpN4ywSD2IGm8eLu7A6M/view"
},
{
  name: "Badminton",
  link: "https://drive.google.com/file/d/182VZKb0NX9PhVX2nMPqzRLb7vYt38Ifp/view"
},
{
  name: "Yoga",
  link: "",
},
{
  name: "100 Meter",
  link: "https://drive.google.com/file/d/1Kw921e6n6fyLtsmM5vdr93lvYSVUvO-e/view"
},
{
  name: "200 Meter",
  link: "https://drive.google.com/file/d/1Kw921e6n6fyLtsmM5vdr93lvYSVUvO-e/view"
},
{
  name: "400 Meter",
  link: "https://drive.google.com/file/d/1Kw921e6n6fyLtsmM5vdr93lvYSVUvO-e/view"
},
{
  name: "Javelin Throw",
  link: ""
},
{
  name: "Shot Put",
  link: ""
},
{
  name: "Discus Throw",
  link: ""
},
{
  name: "Table Tennis",
  link: "https://drive.google.com/file/d/1kWU1y6yDncxvjqgqvGTB3SxTJIRbDYpJ/view?usp=drive_link"
},
{

}]

export default function SingleForm() {
  const studentData = JSON.parse(window.localStorage.getItem("student"));
  const [selectedUniversity, setSelectedUniversity] = useState("");
  const location = useLocation();

  const [selectedCourse, setSelectedCourse] = useState("");

  const [selectedGame, setSelectedGame] = useState("");
  const navigate = useNavigate();

  const submitRegistration = async () => {
    await singleGameRegistration({ game: selectedGame }).then((res) => {
      toast.success("Registration Successful");
      navigate("/browseGame");
    }).catch((err) => {
      console.log(err);
      toast.error(err.message);
    }
    )
  }

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const gameFromUrl = queryParams.get('game');

    if (gameFromUrl && gameFromUrl.includes("Running")) {
      setSelectedGame("100 Meter")
    }

    if (gameFromUrl && games.includes(gameFromUrl)) {
      setSelectedGame(gameFromUrl);
    }
  }, [location.search]);


  const getCourses = () => {
    return selectedUniversity ? universityCourses[selectedUniversity] || [] : [];
  };


  return (
    <div className="min-h-screen p-4 md:p-8">
      <div className="mx-auto max-w-2xl overflow-hidden rounded-lg border border-red-200 bg-white shadow-lg transition-all duration-300 hover:shadow-xl">
        {/* Header */}
        <div className="relative bg-gradient-to-r from-red-500 to-red-600 p-6 text-white">
          <div className="absolute inset-0 opacity-10"></div>
          <div className="relative space-y-1">
            <h1 className="text-3xl font-bold tracking-tight">{selectedGame} Registration</h1>
            <p className="text-sm font-normal text-red-100">Enrolment - {studentData?.enrollmentNumber}</p>
          </div>
        </div>

        <form className="space-y-8 p-6" onSubmit={(e) => {
          e.preventDefault();
          submitRegistration();
        }}>


          {/* Sports Section */}
          <div className="space-y-6">
            <div className="flex items-center gap-2 text-lg font-semibold text-red-600">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <circle cx="12" cy="12" r="10" />
                <path d="M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20" />
                <path d="M2 12h20" />
              </svg>
              <h2>Sports Preference</h2>
            </div>

            <div className="space-y-2">
              <label htmlFor="game" className="text-sm font-medium text-gray-700">
                Select Game
              </label>
              <select
                id="game"
                name="game"
                className="w-full rounded-md border border-red-200 bg-white/50 px-4 py-2 focus:border-red-500 focus:outline-none focus:ring-2 focus:ring-red-500/20"
                required
                value={selectedGame}
                onChange={(e) => setSelectedGame(e.target.value)}
              >
                <option value="">Select your game</option>
                {games.map((game) => (
                  <option key={game} value={game} >
                    {game}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className="space-y-6">
            <div className="flex items-center gap-2 text-lg font-semibold text-red-600">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M22 10v6M2 10l10-5 10 5-10 5z" />
                <path d="M6 12v5c3 3 9 3 12 0v-5" />
              </svg>
              <h2>Academic Information</h2>
            </div>

            <div className="grid gap-6 md:grid-cols-2">
              {/* University Selection */}
              <div className="space-y-2">
                <label htmlFor="university" className="text-sm font-medium text-gray-700">
                  University - {studentData?.university}
                </label>

              </div>



              {/* Course Selection */}
              <div className="space-y-2">
                <label htmlFor="course" className="text-sm font-medium text-gray-700">
                  Course - {studentData?.course}
                </label>

              </div>

              <div className="space-y-2">
                <label htmlFor="semester" className="text-sm font-medium text-gray-700">
                  Semester - {studentData?.semester}
                </label>

              </div>

            </div>
          </div>
          {/* Personal Information Section */}
          <div className="space-y-6">
            <div className="flex items-center gap-2 text-lg font-semibold text-red-600">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                <circle cx="12" cy="7" r="4" />
              </svg>
              <h2>Personal Information</h2>
            </div>

            <div className="grid gap-6 md:grid-cols-2">
              <div className="space-y-2">
                <label htmlFor="name" className="text-sm font-medium text-gray-700">
                  Full Name  - {studentData?.name}
                </label>

              </div>

              <div className="space-y-2">
                <label htmlFor="phone" className="text-sm font-medium text-gray-700">
                  Phone Number - {studentData?.phone}
                </label>

              </div>
            </div>

            {/* Gender Selection */}
            <div className="space-y-3">
              <label className="text-sm font-medium text-gray-700">Gender - {studentData?.gender}</label>

            </div>
          </div>

          <div className="space-y-6">
            <div className="flex items-center gap-2 text-lg font-semibold text-red-600">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                <circle cx="12" cy="7" r="4" />
              </svg>
              <h2>T-Shirt Size</h2>
            </div>

            <div className="grid gap-6 md:grid-cols-2">
              <div className="space-y-2">
                <label htmlFor="size" className="text-sm font-medium text-gray-700">
                  Size - {studentData.tShirtSize}
                </label>

              </div>
            </div>
          </div>



          {/* Academic Information Section */}




          {/* Submit Button */}
          <button
            type="submit"

            className="w-full rounded-md bg-gradient-to-r from-red-500 to-red-600 px-4 py-3 text-sm font-semibold text-white transition-all duration-300 hover:from-red-600 hover:to-red-700 focus:outline-none focus:ring-2 focus:ring-red-500/20"
          >
            Submit Registration
          </button>
        </form>
      </div>
    </div>
  )
}

